import { ApolloStatsTable } from "@/components/ApolloStatsTable/ApolloStatsTable";
import {
  StatsGrouping,
  StatsObject,
  StatsType,
} from "@/components/ApolloStatsTable/const";
import { Flex, Grid } from "@suns/design-system";
import { ApolloGradeDistributionChart } from "../../ApolloGradeDistributionChart";
// eslint-disable-next-line no-restricted-imports -- DO NOT COPY THIS LINE. See docs/lints.md.
import { PlayerRow, StatsQueryParams } from "@suns/api/generated-client/apollo";
import { ApolloShotProfileTable } from "@/components/ApolloShotProfileTable/ApolloShotProfileTable";

export function AmateurPlayerAnalytics({
  player,
  print = false,
}: {
  player: PlayerRow;
  print?: boolean;
}) {
  return (
    <Flex direction="down" gap="md">
      <Grid columns="md:2" gap="lg">
        <ApolloGradeDistributionChart playerMetadata={player.metadata[0]} />
        <ApolloShotProfileTable
          size={print ? "sm" : "md"}
          playerId={player.id}
        />
      </Grid>
      <ApolloStatsTable
        title="Advanced Box Score"
        object={StatsObject.PLAYER}
        grouping={StatsGrouping.SEASON}
        careerRow={false}
        formatSelect={false}
        size={print ? "sm" : "md"}
        defaultMeasureType={StatsType.ADVANCED}
        params={{
          playerId: player.id,
          seasonType: print
            ? StatsQueryParams.seasonType.REGULAR_SEASON
            : undefined,
        }}
      />
    </Flex>
  );
}
